import api from 'apis/config/api-service';
import { toCmsListQuery } from 'apis/config/legacy-table-query';

interface AppUserParams {
  [key: string]: any;
}

export default {
  // Restaurant and supplier app accounts; CMS accounts are excluded by the backend.
  getAppUsers: (params?: AppUserParams) => api.get('api/v1/cms/app-users', { params: toCmsListQuery(params) }),
};
